import _styled from "styled-components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import Icon from "../../../Styled/Icon";
import { StoryIcon } from "./StoryButtons";
import Text from "../../../Styled/Text";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const FooterButton = styled(RawButton).withConfig({
  displayName: "StoryFooterBar__FooterButton",
  componentId: "sc-1jpj94c-0"
})(["display:flex;align-items:center;padding:15px;gap:5px;"]);
const NavigationButton = styled(RawButton).withConfig({
  displayName: "StoryFooterBar__NavigationButton",
  componentId: "sc-1jpj94c-1"
})(["display:flex;align-items:center;flex:1;padding:15px 0;gap:10px;"]);
var _StyledNavigationButton = styled(NavigationButton).withConfig({
  displayName: "StoryFooterBar___StyledNavigationButton",
  componentId: "sc-1jpj94c-2"
})(["justify-content:flex-end;"]);
const FooterBar = _ref => {
  let {
    goPrev,
    goNext,
    jumpToStory,
    zoomTo,
    currentHumanIndex,
    totalStories,
    listStories
  } = _ref;
  const isEnd = currentHumanIndex === totalStories;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      flex: 1,
      children: totalStories > 1 && /*#__PURE__*/_jsxs(NavigationButton, {
        disabled: currentHumanIndex === 1,
        onClick: goPrev,
        children: [/*#__PURE__*/_jsx(StoryIcon, {
          displayInline: true,
          styledWidth: "15px",
          fillColor: "white",
          glyph: Icon.GLYPHS.left
        }), /*#__PURE__*/_jsx(Text, {
          medium: true,
          children: t("story.prev")
        })]
      })
    }), /*#__PURE__*/_jsxs(Box, {
      flex: 1,
      centered: true,
      children: [/*#__PURE__*/_jsx(FooterButton, {
        onClick: listStories,
        children: /*#__PURE__*/_jsx(StoryIcon, {
          displayInline: true,
          styledWidth: "15px",
          glyph: Icon.GLYPHS.menu,
          fillColor: "white"
        })
      }), /*#__PURE__*/_jsx(Box, {
        paddedRatio: 3,
        children: /*#__PURE__*/_jsxs(Text, {
          noWrap: true,
          children: [currentHumanIndex, " / ", totalStories]
        })
      }), /*#__PURE__*/_jsx(FooterButton, {
        onClick: zoomTo,
        title: t("story.locationBtn"),
        children: /*#__PURE__*/_jsx(StoryIcon, {
          styledWidth: "16px",
          glyph: Icon.GLYPHS.location
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      flex: 1,
      right: true,
      children: totalStories > 1 && /*#__PURE__*/_jsx(_StyledNavigationButton, {
        onClick: isEnd ? () => jumpToStory(0) : goNext,
        children: isEnd ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            children: t("story.restart")
          }), /*#__PURE__*/_jsx(StoryIcon, {
            displayInline: true,
            styledWidth: "15px",
            glyph: Icon.GLYPHS.revert,
            fillColor: "white"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            medium: true,
            children: t("story.next")
          }), /*#__PURE__*/_jsx(StoryIcon, {
            displayInline: true,
            styledWidth: "15px",
            glyph: Icon.GLYPHS.right,
            fillColor: "white"
          })]
        })
      })
    })]
  });
};
export default FooterBar;